var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" = ")]),_c('span',{class:_vm.currentRatio > _vm.contrastThreshold ? 'text-success' : 'text-danger'},[_vm._v(" "+_vm._s(_vm.numberFormatter.format(_vm.currentRatio))+" "),_c('i',{staticClass:"fa",class:_vm.currentRatio > _vm.contrastThreshold ? 'fa-check-circle' : 'fa-times-circle'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }